<template>
  <v-container class="px-1 py-1" fluid>
    <v-card-text class="text-h5 font-weight-bold text-center"> {{ $t('ELE0323') }} ({{ $t('ELE0324') }}) </v-card-text>
    <v-card-text>
      <v-row dense class="py-0">
        <v-col cols="6">
          <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
            {{ $t('ELE0127') }}:&nbsp; <span class="text-subtitle-1 font-weight-normal">{{ company }}</span>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8" class="py-0">
          <v-row dense>
            <v-col cols="6">
              <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
                {{ $t('ELE0128') }}:&nbsp; <span class="text-subtitle-1 font-weight-normal">{{ dateFrom }}</span>
              </v-card-text>
            </v-col>
            <v-col cols="6">
              <v-card-text class="text-subtitle-1 font-weight-bold px-1 py-1 text-decoration-underline">
                {{ $t('ELE0129') }}:&nbsp; <span class="text-subtitle-1 font-weight-normal">{{ dateTo }}</span>
              </v-card-text>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card outlined>
            <v-card-title class="pt-1 pb-0">
              {{ $t('ELE0023') }}
              <v-spacer />
            </v-card-title>
            <v-data-table
              :headers="inspLoadListHeaders"
              :items="inspLoadList"
              disable-pagination
              hide-default-footer
              dense
            >
              <template v-slot:header>
                <thead>
                  <tr>
                    <th class="top-headers border-top" colspan="3"></th>
                    <th
                      v-for="(item, index) in weekHeader"
                      v-bind:key="index"
                      :class="`${index !== weekHeader.length - 1 ? 'top-headers' : ''} border-top text-center`"
                      :colspan="item.days"
                    >
                      {{ item.name }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:item.shift="{ item, index }">
                <td :class="getCellClass(index, 'shift')">{{ item.shift }}</td>
              </template>
              <template v-slot:item.type="{ item, index }">
                <td :class="getCellClass(index, 'type')">{{ item.type }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text>
      <v-container class="px-0" fluid>
        <v-row>
          <v-col cols="6" v-for="(item, index) in chartList" :key="`${item.shift}DIM${index}`">
            <InspLoadDimChart :companyName="company" :name="item.shift" :items="item.load" />
          </v-col>
          <v-col cols="6" v-for="(item, index) in chartList" :key="`${item.shift}APP${index}`">
            <InspLoadAppChart :companyName="company" :name="item.shift" :items="item.load" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-container>
</template>

<script>
import InspLoadDimChart from '@/components/organisms/report/chart/InspLoadDimChart.vue'
import InspLoadAppChart from '@/components/organisms/report/chart/InspLoadAppChart.vue'

export default {
  name: 'InspLoadReport',

  components: { InspLoadDimChart, InspLoadAppChart },

  props: {
    company: {
      type: String,
      required: true,
    },
    dateFrom: {
      type: String,
      required: true,
    },
    dateTo: {
      type: String,
      required: true,
    },
    inspLoadListHeaders: {
      type: Array,
      required: true,
    },
    inspLoadList: {
      type: Array,
      required: true,
    },
    weekHeader: {
      type: Array,
      required: true,
    },
    chartList: {
      type: Array,
      required: false,
    },
  },

  methods: {
    getCellClass(index, value) {
      const currentValue = this.inspLoadList[index]?.[value]
      const nextValue = this.inspLoadList[index + 1]?.[value]
      const prevValue = this.inspLoadList[index - 1]?.[value]
      let cellClass = 'v-data-table__divider'
      if (nextValue == undefined || nextValue === currentValue) {
        cellClass = cellClass.concat(' border-b-none')
      }
      if (prevValue && prevValue === currentValue) {
        cellClass = cellClass.concat(' display-none')
      }
      return cellClass
    },
  },
}
</script>
